import { Slot } from "radix-ui";
import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

import { Spinner } from "../spinner";
import { type ButtonVariantProps, buttonVariants } from "./buttonVariants";

type ButtonProps = ComponentProps<"button"> &
  ButtonVariantProps & {
    asChild?: boolean;
    // Действие кнопки идёт: спиннер перед подписью («Запускаем…»), повторно не нажимается.
    loading?: boolean;
  };

export const Button = ({
  className,
  variant,
  size,
  asChild = false,
  loading = false,
  disabled,
  children,
  ...props
}: ButtonProps) => {
  if (asChild) {
    return (
      <Slot.Root
        data-slot="button"
        className={cn(buttonVariants({ variant, size, className }))}
        {...props}
      >
        {children}
      </Slot.Root>
    );
  }
  return (
    <button
      data-slot="button"
      disabled={disabled === true || loading}
      aria-busy={loading || undefined}
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    >
      {loading && <Spinner />}
      {children}
    </button>
  );
};
